import React, { Suspense, Fragment, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import { BASE_URL, BASE_URL1, Home_URL } from './config/constant';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Element props={true} />}</Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

const routes = [
  {
    exact: 'true',
    path: '/login',
    element: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: 'true',
    path: '/auth/signin-1',
    element: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: 'true',
    path: '/auth/signup-1',
    element: lazy(() => import('./views/auth/signup/SignUp1'))
  },
  {
    exact: 'true',
    path: '/auth/reset-password-1',
    element: lazy(() => import('./views/auth/reset-password/ResetPassword1'))
  },
  {
    path: '*',
    layout: AdminLayout,
    routes: [
      {
        exact: 'true',
        path: '/app/dashboard/default',
        element: lazy(() => import('./views/dashboard/index'))
      },
      {
        exact: 'true',
        path: '/collection/collectionRecord',
        element: lazy(() => import('./views/collection/collectionRecord'))
      },
      {
        exact: 'true',
        path: '/donor/donorRecord',
        element: lazy(() => import('./views/donor/donorRecord'))
      },
      {
        exact: 'true',
        path: '/issue/issueRecord',
        element: lazy(() => import('./views/issue/issueRecord'))
      },
      {
        exact: 'true',
        path: '/stock/stockRecord',
        element: lazy(() => import('./views/stock/stockRecord'))
      },
      // {
      //   exact: 'true',
      //   path: '/tables/bootstrap',
      //   element: lazy(() => import('./views/tables/BootstrapTable'))
      // },
      // {
      //   exact: 'true',
      //   path: '/charts/nvd3',
      //   element: lazy(() => import('./views/charts/nvd3-chart'))
      // },
      // {
      //   exact: 'true',
      //   path: '/maps/google-map',
      //   element: lazy(() => import('./views/maps/GoogleMaps'))
      // },
      // {
      //   exact: 'true',
      //   path: '/sample-page',
      //   element: lazy(() => import('./views/extra/SamplePage'))
      // },
      {
        path: '*',
        exact: 'true',
        element: () => <Navigate to={Home_URL} />
      }
    ]
  }
];

export default routes;
